(function (angular) {
  "use strict";

  angular.module("app").controller("eventController", eventController);

  eventController.$inject = [
    "$rootScope",
    "attendeePayload",
    "EventAttendeesApi",
    "eventPayload",
    "Events",
    "EventsApi",
    "modalService",
    "UsersApi",
    "$scope",
  ];

  function eventController(
    $rootScope,
    attendeePayload,
    EventAttendeesApi,
    eventPayload,
    Events,
    EventsApi,
    modalService,
    UsersApi,
    $scope,
  ) {
    var vm = this;
    if ($rootScope.thisUser) {
      vm.thisUserId = $rootScope.thisUser.id;
    }

    // properties
    vm.event = eventPayload;
    vm.eventAttendees = {};
    vm.limit = 4;

    vm.defaultFilters = {
      page: 1,
      page_size: 999,
      attending_event: vm.event.id,
      full_name: "",
      company: "",
      near: "",
      near_distance: 20000,
      industry: "-- All --",
      custom_attrs: {},
    };
    vm.attendeeFilters = angular.copy(vm.defaultFilters);
    vm.getAttendees = getAttendees;
    vm.resetAttendees = resetAttendees;

    vm.attendee = attendeePayload;
    vm.isLoading = false;
    vm.startDateFormatted = window.moment
      .tz(vm.event.starts_at, "UTC")
      .tz("Europe/London")
      .format("ddd Do MMM YYYY hh:mma");
    vm.endDateFormatted = vm.event.ends_at
      ? window.moment
          .tz(vm.event.ends_at, "UTC")
          .tz("Europe/London")
          .format("ddd Do MMM YYYY hh:mma")
      : "";

    vm.event.children = vm.event.children.map(function (child) {
      var startsAt = window.moment
        .tz(child.starts_at, "UTC")
        .tz("Europe/London");
      var endsAt = window.moment.tz(child.ends_at, "UTC").tz("Europe/London");

      if (endsAt.isValid()) {
        child.information = [
          startsAt.format("ddd Do MMM YYYY hh:mma"),
          startsAt.isSame(endsAt, "day")
            ? endsAt.format("hh:mma")
            : endsAt.format("ddd Do MMM YYYY hh:mma"),
        ].join(" - ");
      } else {
        child.information = startsAt.format("ddd Do MMM YYYY hh:mma");
      }

      return child;
    });

    vm.approvedChildEvents = vm.event.children.filter(function (subevent) {
      return subevent.status === "approved";
    });

    // methods
    vm.manageAttendance = manageAttendance;
    vm.letsMeet = letsMeet;
    vm.toggleAttendance = toggleAttendance;
    vm.getEvents = getEvents;
    vm.editEvent = editEvent;

    /**
     * Shows the edit event modal the reloads events
     * @return {void}
     */
    function editEvent() {
      Events.edit(vm.event.id).result.then(function () {
        getEvents();
      });
    }

    /**
     * Retrieves the user's events from the API
     * @return {void}
     */
    function getEvents() {
      EventsApi.get(
        vm.filters,
        function handleGetEventOrdersResponse(response) {
          vm.events = response;
          vm.isLoading = false;
        },
        function handleGetEventOrdersError() {
          vm.isLoading = false;
        },
      );
    }

    function manageAttendance(eventId, ticketId) {
      Events.manageAttendance(eventId, ticketId);
    }

    function letsMeet(user_to) {
      return modalService.open({
        templateUrl: "modals/event-lets-meet.html",
        controller: "eventLetsMeetController",
        controllerAs: "vm",
        resolve: {
          userTo: function () {
            return user_to;
          },
          eventObject: function () {
            return vm.event;
          },
        },
        windowClass: "event-lets-meet",
      });
    }

    /**
     * Adds or removes attendance for the current user.
     *
     * @returns {void}
     */
    function toggleAttendance() {
      if (vm.attendee) {
        EventAttendeesApi.delete({ id: vm.attendee.id })
          .$promise.then(function () {
            vm.attendee = null;
          })
          .catch();
      } else {
        EventAttendeesApi.post({
          event_id: vm.event.id,
          user_id: $rootScope.thisUser.id,
        })
          .$promise.then(function (response) {
            vm.attendee = response.data;
          })
          .catch();
      }
    }

    /**
     * probably needs moving just here temp
     * @param string
     */
    function getInitials(words) {
      var names = words.split(" "),
        initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    }

    /**
     * Retrieves category types from the API and caches to scope
     *
     * @returns {Void}
     */
    function getAttendees() {
      vm.isLoading = true;

      var filters = angular.copy(vm.attendeeFilters);
      $scope.loadMore = function () {
        var increamented = vm.limit + 4;
        vm.limit =
          increamented > vm.eventAttendees.length
            ? vm.eventAttendees.length
            : increamented;
      };

      // Nasty way of parsing the "all" option back out of the query filters
      if (filters.industry === "-- All --") {
        filters.industry = "";
      }

      UsersApi.get(
        filters,
        function handleGetAttendeesSuccess(response) {
          vm.eventAttendees = response;
          vm.isLoading = false;

          //Below is to catch users who have signed up but arent members
          //check if event attendees is not null
          if (vm.event.attendees.length > 0) {
            //loop over all vm.event.attendees
            vm.event.attendees.forEach((attendee) => {
              //if user id is null, then add them to the event attendees list
              if (attendee.user_id == null) {
                // eslint-disable-next-line no-param-reassign
                attendee.initials = getInitials(attendee.full_name);
                vm.eventAttendees.data.push(attendee);
              }
            });
          }
        },
        function handleGetAttendeesError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Reset the attendees
     *
     * @returns void
     */
    function resetAttendees() {
      vm.attendeeFilters = angular.copy(vm.defaultFilters);
      getAttendees();
    }

    // go!
    (function () {
      getAttendees();
    })();
  }
})(angular);
